import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class NavStateService {
  private state: any = null;

  setState(data: any) {
    this.state = data;
  }

  getState(): any {
    const temp = this.state;
    this.state = null; // clear after reading
    return temp;
  }
}